import Popup from 'reactjs-popup';
import styled from 'styled-components';

export const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px 16px;

	&.confirmation-modal{
		padding:1rem 1rem .5rem;
	}
`;

export const ModalHeader = styled.h4`
	color: var(--textHeadingColor);
	align-self: center;
  margin-top: 0px;
  padding: 2px 0px;
	margin-bottom:6px;
	font-size: 1.25rem;
	font-weight: 600;

	&.confirmation-modal-head{
	font-size: 1.5rem;
	margin-bottom: 12px;
	color: var(--textHeadingColor);
	}
`;
export const ModalContent = styled.div`
	font-family: Inter;
	font-size: 0.95rem;
	line-height: 1.42;
	display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 0px 0px 10px;
	color: var(--textColor);
	align-items: center;
  justify-content: center;
	text-align: center;

	

`;

export const ModalFooter = styled.div`
	display: flex;
	align-self: flex-end;
	justify-content: flex-end;
  margin-top: 10px;
	bottom: 5px;
	flex-direction: row-reverse;
	gap: 15px;
	padding-bottom: 20px;
	padding-right: 40px;
	width: 100%;

	button{
			border: 1px solid var(--primary);
			background: var(--primary);
			padding: 10px 22px;
			border-radius: 3px;

			&:hover, &:focus{
				background: #0639dc;
			}

			&.btn-no{
			color: var(--textColor);
      background: transparent;
			border: 1px solid var(--controlBorderColor);

				&:hover, &:focus{
				background: var(--controlHoverBgColor);
					}
			}
	}
			&.confirmation-modal-footer{
				justify-content: center;
				padding-right: 0;
				margin-top:20px;
			}
			&.btn-action-modal-wrap{
				button{
				gap:0;
				 span{
					text-decoration: underline;
				 }
				}
			}	
`;

export const ConfirmationPopup = styled(Popup)`
  &-content {
    max-width: 580px;
    border-radius: 4px;
  	margin-top: 120px !important;
		@media (max-width: 540px) {
			width: 84%;	
		}
		background: var(--modalBgColor);
		border: 1px solid var(--modalBorderColor);
  }
`;
export const ModaliconInfo = styled.div`
	margin-bottom: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const DivNote = styled.div`

		color: red;
		font-size: 1rem;
		font-weight: 600;
		line-height: 1.2;
		color: var(--dangerTextColor);
		background: var(--dangerBgColor);
		padding: .75rem 1rem;
		border-radius: .5rem;
		margin-top: .75rem; 

		span{
			font-size: .875rem;
			font-weight: 500;
		}
`;

